import { render, staticRenderFns } from "./DashboardRetail.vue?vue&type=template&id=64f2ac7f&"
import script from "./DashboardRetail.vue?vue&type=script&lang=js&"
export * from "./DashboardRetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports